<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';

const { row } = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const { accountScopedRoute } = useAccount();

const routerParams = computed(() =>
  accountScopedRoute(
    'inbox_conversation',
    { conversation_id: row.original.conversationId },
    row.original.messageId ? { messageId: row.original.messageId } : {}
  )
);
</script>

<template>
  <div class="text-right">
    <router-link
      :to="routerParams"
      class="font-medium text-n-brand hover:underline"
    >
      {{ `#${row.original.conversationId}` }}
    </router-link>
    <div
      v-tooltip="row.original.createdAt"
      class="text-slate-600 dark:text-slate-200 text-sm"
    >
      {{ row.original.createdAgo }}
    </div>
  </div>
</template>
